import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import {
  ApiDownloadButton,
  ContentLabel,
  CopyButton,
  Link
} from 'components/common';
import { Box } from 'components/common/box';
import { CourseQRCode, CourseShareCode } from 'components/courses/common';

const ShareLinks = () => {
  const {
    messages,
    pageState: { course },
    serverConfig: { adminUrl, courseEnableShareCode, courseEnableShareQRCode },
    theme
  } = useReduxState();

  if (!course) return null;

  return (
    <div className="share-links">
      <Box title={messages.commonSharing}>
        <ContentLabel
          label={messages.commonCourseLink}
          verticalLabelSpacing={5}
        >
          <div className="link">
            <Link
              href={`${adminUrl}/courses/${course.slug}`}
              text={`${adminUrl.replace(/https?:\/\//, '')}/courses/${
                course.slug
              }`}
            />
          </div>
          <div className="copy-button">
            <CopyButton
              category="light"
              size="small"
              successText={messages.commonCopied}
              text={messages.commonCopyLink}
              value={`${adminUrl}/courses/${course.slug}`}
            />
          </div>
        </ContentLabel>

        {courseEnableShareCode ? (
          <ContentLabel
            label={messages.coursesShareCode}
            style={{ marginTop: 40 }}
            verticalLabelSpacing={5}
          >
            <CourseShareCode
              codeFontSize="2.6rem"
              course={course}
              infoFontSize="1.4rem"
              isReader={false}
            />
          </ContentLabel>
        ) : null}

        {courseEnableShareQRCode ? (
          <ContentLabel
            label={messages.commonShareQRCode}
            style={{ marginTop: 40 }}
            verticalLabelSpacing={5}
          >
            <div className="qr-code">
              <CourseQRCode course={course} padding={15} size={120} />
            </div>
          </ContentLabel>
        ) : null}

        {courseEnableShareCode || courseEnableShareQRCode ? (
          <ApiDownloadButton
            category="light"
            filename={`${course?.slug}.pdf`}
            icon="file-pdf"
            style={{ marginTop: 30 }}
            text={messages.commonDownloadPdf}
            url={`/admin/courses/${course?.id}/share-info`}
          />
        ) : null}
      </Box>

      <style jsx>{`
        .share-links {
          color: ${theme.textColorLight};
          width: 100%;
        }
        .link {
          font-size: 1.6rem;
          white-space: pre-wrap;
          word-wrap: break-word;
        }
        .copy-button {
          margin-top: 10px;
        }
        .qr-code {
          background-color: ${theme.lightGrey};
          border-radius: 10px;
          display: inline-block;
          margin-top: 5px;
          padding: 15px;
        }
        @media (max-width: ${breakpoints.medium}px) {
          .share-links {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default ShareLinks;
